import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer, { rootSaga } from './modules';
import { HelmetProvider } from 'react-helmet-async';
import { configureStore } from '@reduxjs/toolkit';
import { QueryClientProvider } from '@tanstack/react-query';
import { RecoilRoot } from 'recoil';
import Modal from 'react-modal';
import TagManager from 'react-gtm-module';
import { Toaster } from 'react-hot-toast';
import ReduxThunk from 'redux-thunk';
import ScrollToTop from 'ScrollToTop';
import { queryClient } from 'api/query_client';
import './styles/styles.scss';
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: [ReduxThunk, sagaMiddleware],
});

sagaMiddleware.run(rootSaga);

const tagManagerArgs = {
  gtmId: 'GTM-KFQVGFR',
};

// TagManager.initialize(tagManagerArgs); // gtm에서 미리보기 테스트위해서는 stg 허용해줘야 합니다.

console.log(process.env.REACT_APP_SERVER_BASE_URL);
process.env.REACT_APP_SERVER_BASE_URL === 'prd' &&
  TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Router>
        <HelmetProvider>
          <ScrollToTop />
          <RecoilRoot>
            <App />
          </RecoilRoot>
        </HelmetProvider>
      </Router>
      <Toaster
        reverseOrder={true}
        toastOptions={{
          duration: 2000,
          style: {
            marginTop: '50px',
            fontSize: '13px',
            fontWeight: '700',
            color: '#3d3d3d',
            wordBreak: 'break-all',
          },
        }}
      />
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root'),
);

Modal.setAppElement('#root');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export type AppDispatch = typeof store.dispatch;
